(function(global) {

    function PaaSBall(elementId, productId, isShowVar) {
        /* ------------ 版本号 ------------ */
        this.version = '2.1.0.5';

        /* ------------ API Url ------------ */
       this.API_BASE_URL = 'https://app.paas3d.com/';
       this.THREE_URL = 'https://cdn.paas3d.com/SHOPIFY_THEME_SCRIPT_TAGS/Paas3dThreeD.js?v1.1.1';

        /* ------------ shopify params ------------ */
        this.productId = productId; // 产品ID
        this.isShowVar = isShowVar ; // 是否显示变体块
        this.domain = ''; // 店铺域名
        this.classicTemplate = ['Boundless', 'Brooklyn', 'Debut', 'Express', 'Minimal', 'Narrative', 'Simple', 'Supply', 'Venture']; // shopify经典模板 - 1.0模板
        this.currentTemplate = ''; // 当前店铺使用的模板

        /* ------------ style params ------------ */
        this.fontFamily = 'inherit'; // 店铺主题字体

        /* ------------ API params ------------ */
        this.apiData = {}; // api数据
        this.themeData = {}; // 主题数据
        this.config3d = {}; // 3D&产品数据

        /* ------------ DOM结构 ------------ */
        this.mainContent = document.querySelector('#' + elementId); // 获取shopify商品页面的主页面
        this.loadingPageIframe = null; // 页面加载的iframe
        this.loadingPageDOM = null; // 页面的加载DOM
        this.mainFrame = null; // 总的iframe
        this.paaSMainDom = null; // 
        this.paaSMainContent = null; // paaS-main-content
        this.themeDisplayDom = null; // 3D模型DOM
        this.themeEditDom = null; // 产品信息DOM
        this.editContentDom = null; // 编辑页面DOM
        this.titlePriceDom = null; // 价格和总标题的DOM
        this.priceDom = null; // 价格DOM
        this.dropDownInputObj = null; // 当前的radio input对象
        this.currentLiHeadObj = null; // 当前被点击的head对象
        this.addToCart = null; // addToCart
        this.confirmBtn = null; // confirmBtn
        this.addToCartLoadingDom = null; // addToCart加载动画
				
        /* ------------ 常量 ------------ */
        this.equipment = window.innerWidth > 1023 ? 'pc' : 'mobile'; // 当前设备
        this.headClickFlag = 1; // head点击防抖
        this.liOpenOrCloseFlag = 0; // li - head是否打开
        this.addToCartFlag = 1; // addToCart按钮防抖 
        this.selectedVariantIdArray = []; // 存储选中的3D数据的ID
        this.selectVariantObj = []; // 存储isDefault为true的变体数据
        this.setConfig3DAnswer = []; // 单个编辑的3D模型数据
        this.setConfig3DAnswerGroup = []; // 混合编辑的3D模型数据

        this.listenerLoad();
        this.listenerResize();
        this.initParams();
        // this.findMountDom();
        this.initPage();
    }

    PaaSBall.prototype = {

        // 初始化Shopify参数
        initParams() {
			this.domain = 'dmada-creative.myshopify.com'; //Shopify.shop ;

            let symbol = {USD:'$', GBP:'￡', CAD:'$', EUR:'€', NZD:'$', JPY:'¥', AUD:'$', CNY:'¥', RUB:'₽', HKD:'$'};
            // 货币
            this.currency = Shopify.currency.active.toUpperCase();
            // 货币符号
            this.symbol = symbol[this.currency] === undefined ? '' : symbol[this.currency];
            // 当前主题名称
            this.currentTemplate = Shopify.theme.name; 
        },

        // 【新增】 - 找寻脚本挂载的位置DOM
        findMountDom() {
            // 目标DOM
            const targetDom = this.findMountDomChild(this.mainContent);
            if (targetDom) {
                this.mainContent = targetDom;
            }
        },

        // 【新增】 - 找挂载DOM的方法封装
        findMountDomChild(currentDom) {
            // 限制最大递归次数为6次
            if (this.findDomCount > 5) {
                return this.mainContent;
            }
            this.findDomCount++;

            const domChildArray = currentDom.children;
            for (let i = 0; i < domChildArray.length; i++) {
                if (domChildArray[i].id != undefined && ['shopify-section-'].includes(domChildArray[i].id)) {
                    // 找到了 - 暂定的标准是第一个高度大于500的元素
                    if (domChildArray[i].clientHeight >= 500) {
                        // 记录下标
                        this.findDomIndex = i;
                        return domChildArray[i];
                    }
                } else {
                    // 没找到 - 做递归
                    return this.findMountDomChild(domChildArray[i]);
                }
            }
        },

        // 页面加载时
        listenerLoad() {
            window.addEventListener('load', () => {
                this.listenerWindowChange();
            })
        },

        // 页面改变时
        listenerResize() {
            window.addEventListener('resize', () => {
                this.listenerWindowChange();
            })
        },

        // resize窗口
        listenerWindowChange() {
            if (window.innerWidth <= 1023 && this.equipment === 'pc') {
                this.equipment = 'mobile';
                if (this.editContentDom != null) {
                    this.editContentDom.style.height =  `calc(100% - 25px)`;
                }
                
            } else if (window.innerWidth > 1024 && this.equipment === 'mobile') {
                this.equipment = 'pc';
                if (this.editContentDom != null) {
                    this.editContentDom.style.height =  `calc(100% - ${this.titlePriceDom.offsetHeight}px - 55px)`;
                }
            }
        },

        // 页面初始化
        initPage() {
            // 首先判断是否是商品详情页面
            // if (window.location.href.indexOf(`/product`) === -1) {
            //     console.log(' -- The script stops loading because routes do not match -- ');
            //     return ;
            // } 

            // 获取店铺字体
            const fontFamily = getComputedStyle(document.body).getPropertyValue('font-family');
            if (fontFamily != '') {
                this.fontFamily = fontFamily;
            }

            // 请求真实数据
            this.getApiData();

            // 请求模拟数据
            // this.getJsonDataApi();
        },

        // 真实后端接口请求数据
        getApiData() {
            const that = this;

            // 请求后端API
            this.ajaxRequest({
                url: `${this.API_BASE_URL}web/3dConfig/info/${this.domain}/${this.productId}?type=0`,
                
                method: 'get',
                success: function(data) {
                    const params = JSON.parse(data);
                    if (params.code === 200) {
                        console.log('params ----------- ', params);
                        that.apiData = params.data;

                        // that.getJsonDataApi();
                        that.themeData = that.apiData.themeConfig;
                        that.config3d = that.apiData.config3d;

                        if (that.config3d.modelType === 'gltf') {
                            const originalUrlArray = that.config3d.originalUrl.split(',');
                            originalUrlArray.forEach(item => {
                                if (item.indexOf('.gltf') > -1) {
                                    that.config3d.originalUrl = item;
                                }
                            });
                        }
                        
                        that.createMainPage();
                    } else {
                        console.log(' -- PaaS3D: product data error or request error -- ');
                    }
                }
            });
        },

        // 模拟数据 - api
        getJsonDataApi() {
            let url = 'apiNewParams.json';
            let request = new XMLHttpRequest();
            request.open('get', url);
            request.send(null);
            request.onload = () => {
                if (request.status === 200) {
                    this.apiData = JSON.parse(request.responseText);
                    console.log('apiData ------------ ', this.apiData);
                    // this.themeData = this.apiData.themeConfig;
                    this.config3d = this.apiData.config3d;
                    this.createMainPage();
                }
            }
        },

        // ajax请求封装
        ajaxRequest(obj) {
            obj.method = (obj.method || 'post').toLowerCase();
            obj.async = obj.async || true;
            // obj.data = formatParams(obj.data);

            // 创建XMLHttpRequest对象
            let xhttp = new XMLHttpRequest() || new ActiveXObject('Microsoft.XMLHTTP');

            // 设置事件处理程序
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState === 4 && xhttp.status === 200) {
                    obj.success(xhttp.responseText);
                }
            };

            // 设置带参数的get请求
            if (obj.method == 'get' && obj.data) {
                obj.url =  `${obj.url}?${obj.data}`;
            }

            // 设置请求相关的数据
            xhttp.open(obj.method, obj.url, obj.async);
            if (obj.method == 'post') {
                // 设置请求头
                xhttp.setRequestHeader('Content-type', 'application/json');
                // 发送请求
                xhttp.send(JSON.stringify(obj.data));
            } else {
                xhttp.send();
            }

            function formatParams(data) {
                var arr = [];
                for (var name in data) {
                    arr.push(encodeURIComponent(name) + "=" + encodeURIComponent(data[name]))
                };
                arr.push(("v=" + Math.random()).replace(".", ""));
                return arr.join("&");
            };
        },

        // 添加CSS文本
        initStyle(params) {
            // PC端 - 编辑左右排版
            let flexDirection = 'row';
            if( this.themeData.questionPanel.QPPosition === 'Left') {
                flexDirection = 'row-reverse';
            }

            // 价格文本的位置
            let pricePosition = '0px';
            if (this.themeData.price.pricePosition === 'Right') {
                pricePosition = 'auto';
            }

            let summaryTitleStatus = 'block';
            if (!this.themeData.summaryTitle.SummaryTitleStatus) {
                summaryTitleStatus = 'none';
            }

            // 脚本的CSS文本 - 后面做一个文件封装，进行引入
            const styleText = `
                body { margin:unset !important; font-family:${this.fontFamily}; user-select: none; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; }
                ul { margin:0; padding:0; height:100%; }
                ul > li { list-style:none; }

                // .paaS-loading { width:120px; height:120px; position:absolute; top:calc(50% - 60px); left:calc(50% - 60px); border:6px solid #f7f7f7; border-bottom-color:${this.themeData.customizer.CutomizerLoadingIconColor}; border-radius:50%; animation:paasRotation 1s infinite; -webkit-animation:paasRotation 0.8s linear infinite; }
                // @keyframes paasRotation { 0% { transform: rotate(0deg) } 100% { transform: rotate(360deg) }}
                // @-webkit-keyframes paasRotation { 0% { transform: rotate(0deg) } 100% { transform: rotate(360deg) }}

                // .paaS-main-dom {box-sizing: border-box; height:100%; padding: 10px; display: flex; justify-content: center; visibility: hidden; }
                .paaS-main-dom {box-sizing: border-box; height:100%; display: flex; justify-content: center; visibility: hidden; }
                //.paaS-main-content { display: flex; flex-direction: ${flexDirection}; max-width: 1200px; min-width: 414px; width: 100%; box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2); border-radius: 10px; overflow: hidden; background-color: #f5f8fa; }
                .paaS-main-content { display: flex; flex-direction: ${flexDirection}; max-width: 1200px; width: 100%; overflow: hidden; }

                .theme-display { height: 100%; overflow: hidden; position: relative; z-index: 2; padding: 0 0 0 0; box-sizing: border-box; }
                .theme-display_content { height: 100%;}
                .view { position: relative; width: 100%; height: 100%; }
                .edit-display-footer { position: absolute; bottom: 5px; left: 5px; font-size: 14px; letter-spacing: 0.5px; color: #7e7e7e; font-style: italic; }

                .theme-edit { width: 400px; height: 100%; position: relative; }
                .title-price { padding: 1rem 16px; display: flex; flex-direction: column;background-color:${this.themeData.customizerTitle.CTBackgroundColor};  box-sizing: border-box; }
                .title { color: ${this.themeData.customizerTitle.CTFontColor}; font-size: ${this.themeData.customizerTitle.CTTitleFontSize}px; line-height: normal;}
                .price { color: ${this.themeData.price.PriceFontColor}; font-size: ${this.themeData.price.priceFontSize}px; margin-left: ${pricePosition}; }

                .edit-content { overflow-y: auto; overflow-x: auto;height: calc(100% - 100px);  border-top: ${this.themeData.questionPanel.QPBorderThickness}px solid ${this.themeData.questionPanel.QPBorderColor}; box-sizing: border-box; }
                .edit-content::-webkit-scrollbar { width: 5px; }
                .edit-content::-webkit-scrollbar-thumb { background: #c8c8c8; }
                .edit-content::-webkit-scrollbar-thumb:hover { background: #683bf4; border-radius: 18px; }
                .edit-content-ul { height: 100%;background-color: ${this.themeData.questionPanel.QPBackgroundColor};  }
                .edit-content-li { width: 100%; cursor: pointer; transition: transform 500ms; }
                .edit-content_head { display: flex; justify-content: space-between; align-items: center;background-color: ${this.themeData.questionPanel.QPBackgroundColor};  padding: 16px; line-height: 24px; border-bottom: ${this.themeData.questionPanel.QPBorderThickness}px solid ${this.themeData.questionPanel.QPBorderColor}; height: 72px; box-sizing: border-box; transition: transform 500ms; }
                .edit-content_head:hover { background-color: ${this.themeData.questionPanel.QPHoverBackgroundColor}; }
                .head_title { max-width: 180px; color: ${this.themeData.question.QFontColor}; font-size: ${this.themeData.question.QFontSize}px; }
                .head_result { display: ${summaryTitleStatus}; width: 160px; overflow: hidden; text-align: end; color: ${this.themeData.summaryTitle.SummaryTitleFontColor}; font-size: ${this.themeData.summaryTitle.SummaryTitleFontSize}px; }
                .head_title, .head_result { pointer-events: none; }

                .edit-content_body { display: none; padding-bottom: 20px; height: 516px; overflow-y: auto; box-sizing: border-box; }
                .edit-content_body::-webkit-scrollbar { width: 5px; }
                .edit-content_body::-webkit-scrollbar-thumb { background: #c8c8c8; }
                .variant-description, .sub_head_title { padding: 12px 19px 0 19px; }
                .sub_head_title { color: ${this.themeData.answer.AAnswerTextColor}; font-size: ${this.themeData.answer.AAnswerFontSize}px; }
                .variant-description { color: ${this.themeData.answer.ADescriptionFontColor}; font-size: ${this.themeData.answer.ADescriptionFontSize}px; }

                .type-one-content { display: flex; flex-wrap: wrap; padding-bottom: 19px; }
                .thumbnail-btn-content { margin: 20px 18px 0; }
                .thumbnail-btn { display: flex; height: ${this.themeData.thumbnailsButton.ThumbnailsBtnSize}px; width: ${this.themeData.thumbnailsButton.ThumbnailsBtnSize}px; align-items: center; background-color: #d2d2d2; border: ${this.themeData.answer.AAnswerBorderThickness}px solid ${this.themeData.answer.AAnswerBorderColor}; border-radius: ${this.themeData.thumbnailsButton.ThumbnailsBtnRounding}%; cursor: pointer; overflow: hidden; box-sizing: border-box; }
                .thumbnail-btn > img { width: 100%; height: 100%; pointer-events: none; }
                .thumbnail-btn-active { border-color: ${this.themeData.answer.ASelectAnswerBorderColor}; }
                .thumbnail-btn-variant-name { word-wrap: break-word; font-size: 12px; margin-top: 12px; text-align: center; width: 62px; word-break: break-all; color: ${this.themeData.answer.AAnswerTextColor}; font-size: ${this.themeData.answer.AAnswerFontSize}px; }

                .type-two-content { padding: 19px; position: relative; }
                .type-two-content > input { width: 100%; height: ${this.themeData.textInputAndDropdown.TextInputHeight}px; border-radius: ${this.themeData.textInputAndDropdown.TextInputRounding}px; padding: 12px 13px; box-sizing: border-box; border:transparent; border:2px solid #5c5f62; background-color: ${this.themeData.textInputAndDropdown.TextInputBackgroundColor}; color: ${this.themeData.textInputAndDropdown.TextInputFontColor}; font-size: ${this.themeData.textInputAndDropdown.TextInputFontSize}px; }
                .type-two-content > ul { display: none; position: absolute; height: auto; width: 90.5%; margin-top: 4px; padding: 8px; box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.1); border-radius: 8px; background-color: ${this.themeData.textInputAndDropdown.DropdownBackgroundColor}; color: ${this.themeData.textInputAndDropdown.DropdownFontColor}; box-sizing: border-box; z-index: 1; }
                .type-two-content > ul > li { padding: 8px 10px; box-sizing: border-box; cursor: pointer; font-size: 14px; }
                .type-two-content > ul > li:hover { background-color: #f6f6f7; border-radius: 4px; }

                .type-three-content { padding: 19px 14px; }
                .radio { position: relative; line-height: 30px; }
                input[type="radio"] { width: 14px; height: 14px; opacity: 0; }
                .radio label { position: absolute; left: 5px; top: 7px; width: 14px; height: 14px; border-radius: 50%; border: 1px solid ${this.themeData.answer.AAnswerBorderColor}; }
                input[type="radio"]:checked + label { background-color: unset; border: 1px solid ${this.themeData.answer.ASelectAnswerBorderColor}; }
                input[type="radio"]:checked + label::after { position: absolute; content: ""; width: 14px; height: 14px; background-color: ${this.themeData.answer.ASelectAnswerBorderColor}; background-clip: content-box; padding: 0.2rem; top: 0px; left: 0px; box-sizing: border-box; border-radius: 50%; }
                .type-three-content > .radio > span { display: inline-block; margin-left: 21px; color: ${this.themeData.answer.AAnswerTextColor}; font-size: ${this.themeData.answer.AAnswerFontSize}px; }

                .type-four-content { display: flex; flex-wrap: wrap; padding: 19px 19px 0; justify-content: space-between; }
                .label-button { width: 170px; min-height: 47px; padding: 13px 8px; border: transparent; border-radius: 4px; overflow-x: hidden; margin-bottom: 19px; cursor: pointer; background-color: #fff; font-size: ${this.themeData.answer.AAnswerFontSize}px; color: ${this.themeData.answer.AAnswerTextColor}; }
                .label-button-active { border: ${this.themeData.answer.AAnswerBorderThickness}px solid ${this.themeData.answer.ASelectAnswerBorderColor}; }

                .type-five-content { padding: 19px; }
                .text-input { width: 100%; height: ${this.themeData.textInputAndDropdown.TextInputHeight}px; border-radius: ${this.themeData.textInputAndDropdown.TextInputRounding}px; padding: 12px 13px; box-sizing: border-box; border:transparent; border:2px solid #5c5f62; margin-top: 20px; background-color: ${this.themeData.textInputAndDropdown.TextInputBackgroundColor}; color: ${this.themeData.textInputAndDropdown.TextInputFontColor}; font-size: ${this.themeData.textInputAndDropdown.TextInputFontSize}px; }
                .type-five-content > div:first-child > input { margin-top: unset; }

                .card-comfirm {display:flex; bottom:0;position: absolute; flex-direction: row; width: 100%; height: 55px; overflow: hidden; }
                .add-to-cart { width: 100%; height: 100%; cursor: pointer; border-left: 1px solid #5c5c5c; background-color: ${this.themeData.addToCart.AddToCardBackgroundColor}; color: ${this.themeData.addToCart.AddToCardFontColor}; font-size: ${this.themeData.addToCart.AddToCardFontSize}px; position: absolute; bottom: 0; transition: transform 500ms; overflow: hidden; white-space: nowrap; line-height: 55px; text-overflow: ellipsis; text-align: center; }
                .cart-loading { display: flex; justify-content: center; align-items: center; height: 100%; }
                .add-to-cart:hover { background-color: ${this.themeData.addToCart.AddToCardHoverBackgroundColor}; }
                .confirm-btn { display: flex; justify-content: center; align-items: center; left: -414px; }

                .cart-loading-dom { display:flex; justify-content:center; align-items:center; height:100%; }
                .spinner { width:50px; height:40px; text-align:center; font-size:10px; }
                .spinner > div { height:100%; width:6px; display:inline-block; animation:stretchdelay 1.2s infinite ease-in-out; -webkit-animation:stretchdelay 1.2s infinite ease-in-out; margin-right:3px; background-color:${this.themeData.customizer.AddToCartLoadingColor}; }
                .rect2 { animation-delay:-1.1s !important; -webkit-animation-delay:-1.1s !important; }
                .rect3 { animation-delay: -0.9s !important; -webkit-animation-delay:-0.9s !important; }
                @-webkit-keyframes stretchdelay { 0%, 40%, 100% { -webkit-transform:scaleY(0.4); } 20% { -webkit-transform: scaleY(1.0); }}
                @keyframes stretchdelay { 0%, 40%, 100% { transform:scaleY(0.4); -webkit-transform:scaleY(0.4); } 20% { transform: scaleY(1.0); -webkit-transform:scaleY(1.0); }}

                .paaS-error-dialog { animation:errorDialog 5s; position:absolute; bottom:-100px; left:calc(50% - 170px); border-top:2px solid ${this.themeData.questionPanel.QPErrorColor}; color:${this.themeData.questionPanel.QPErrorColor}; background-color:#fffae6; padding:1.2rem 1rem; border-radius:5px; box-shadow:0 0 0.3125rem rgb(23 24 24 / 5%), 0 0.0625rem 0.125rem rgb(0 0 0 / 15%); z-index:101; font-size:14px; width:340px; box-sizing:border-box; }
                @-webkit-keyframes errorDialog { 0%{ bottom:-100px; } 20%{ bottom:100px; } 80%{ bottom:100px; } 100%{ bottom:-100px; }}
                @keyframes errorDialog { 0%{ bottom:-100px; } 20%{ bottom:100px; } 80%{ bottom:100px; } 100%{ bottom:-100px; }}

                @media screen and (max-width: 1007px) {
                    // .paaS-main-content { flex-direction: column; width: 414px; }
                    .paaS-main-content { flex-direction: column; }

                    .theme-display { height: 523px; width: 100%; padding: 30px 0; }
                    .edit-display-footer { font-size: 12px; bottom: 3px; }

                    // .theme-edit { height: 254px; width: 414px; }
                    .theme-edit { height: 254px; width: 100%; }
                    .title-price { height: 43px; align-items: center; flex-direction: row; font-size: 14px; justify-content: space-between; padding: 0.25rem 1rem; }
                    .title { font-size: 20px; line-height: 20px; }
                    .price { font-size: 16px; margin-left: auto; }

                    .edit-content-ul { display: flex; flex-direction: row; overflow-x: auto; width: 100%; position: relative; }
                    .edit-content_head { width: 196px; height: 100%; justify-content: center; border-bottom: unset; border-right: ${this.themeData.questionPanel.QPBorderThickness}px solid ${this.themeData.questionPanel.QPBorderColor}; }
                    .head_title { text-align: center; font-size: 16px; }
                    .head_result { display: none; }

                    .edit-content_body { position: absolute; top: 0; width: 414px; height: 100%; }
                    .variant-description { font-size: 16px; }

                    .thumbnail-btn { width: 60px; height: 60px; }
                    .type-two-content > input, .text-input { font-size: 16px; }
                    .sub_head_title, .type-three-content > .radio > span, .label-button { font-size: 12px; }
                    .sub_head_title { text-align: left; }

                }
            `;

            const style = document.createElement('style');
            const text = document.createTextNode(styleText);
            style.appendChild(text);

            if (params.frame == document.body) {
                params.frame.appendChild(style);
            } else {
                params.frame.contentWindow.document.body.appendChild(style);
            }

						if(this.editContentDom){
							if (this.equipment == "pc")
							{
									this.editContentDom.style.height =  `calc(100% - ${this.titlePriceDom.offsetHeight}px - 55px)`;
							} else {
									this.editContentDom.style.height =  `calc(100% - 25px)`;
							}
						}
        },

        // 初始化外部JS
        initScript(params) {
            if (params.frame == document.body) {
                params.frame.appendChild(style);
            } else {
                params.frame.contentWindow.document.body.appendChild(params.script);
            }
        },

        // 创建iframe
        createIframe(params) {
            const iframe = document.createElement('iframe');

            if (params.title) iframe.setAttribute('title', params.title);
            if (params.className) iframe.setAttribute('class', params.className);
            if (params.id) iframe.setAttribute('id', params.id);
            iframe.setAttribute('frameborder', 0);
            iframe.setAttribute('scrolling', 'no');
            return iframe;
        },

        // 创建DOM
        createDom(params) {
            const _dom = document.createElement(params.type);
            if (params.className) _dom.setAttribute('class', params.className);
            if (params.id) _dom.setAttribute('id', params.id);
            if (params.text) _dom.innerHTML = params.text;
            if (params.way) _dom.type = params.way;
            if (params.style) _dom.setAttribute('style', params.style);
            if (params.for) _dom.setAttribute('for', params.for);
            return _dom;
        },

        // 创建radio
        createRadio(params) {
            const groupData = params.groupData;
            const variantItem = params.variantItem;

            const _dom = document.createElement('input');
            let radioName = `radio-${groupData.id}`;

            if (groupData.sortby != undefined) {
                radioName = `radio-${groupData.sortby}`;
            }
            
            _dom.type = 'radio';
            if (params.className) _dom.setAttribute('class', params.className);
            _dom.id = variantItem.id;
            _dom.name = radioName;
            _dom.value = variantItem.id;
            _dom.defaultChecked = variantItem.isDefault;
           
            return _dom;
        },

        // 创建svg
        createSVG() {
            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('style', 'width:30; height:30');
            svg.setAttribute('viewBox', '0 0 20 20');

            const fan = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            fan.setAttribute('d', 'M7.29325 14.7066L4.29325 11.7066C3.90225 11.3156 3.90225 10.6836 4.29325 10.2926C4.68425 9.90159 5.31625 9.90159 5.70725 10.2926L7.94325 12.5286L14.2413 5.34959C14.6012 4.92959 15.2323 4.88159 15.6503 5.24059C16.0703 5.60059 16.1192 6.23059 15.7592 6.64959L8.75925 14.6496C8.57825 14.8616 8.31625 14.9876 8.03825 14.9986C7.73525 14.9996 7.48025 14.8946 7.29325 14.7066Z');
            fan.setAttribute('style', `fill:${this.themeData.addToCart.AddToCardFontColor}`);

            svg.appendChild(fan);
            return svg;
        },

        // 创建加载页面 Loading
        createLoadingPage() {
            this.loadingPageIframe = this.createIframe({
                title: 'PaaS3D Loading',
                className: 'paas-3d-loading-frame',
                id: 'paas-3d-loading-frame'
            });

            this.loadingPageDOM = this.createDom({
                type: 'div',
                className: 'paaS-loading'
            });

            const styleText = `
                .paaS-loading { width:120px; height:120px; position:absolute; top:calc(50% - 60px); left:calc(50% - 60px); border:6px solid #f7f7f7; border-bottom-color:${this.themeData.customizer.CutomizerLoadingIconColor}; border-radius:50%; animation:paasRotation 1s infinite; -webkit-animation:paasRotation 0.8s linear infinite; }
                @keyframes paasRotation { 0% { transform: rotate(0deg) } 100% { transform: rotate(360deg) } }
                @-webkit-keyframes paasRotation { 0% { transform: rotate(0deg) } 100% { transform: rotate(360deg) } }
            `;
            const style = document.createElement('style');
            const text = document.createTextNode(styleText);
            style.appendChild(text);
            this.mainContent.appendChild(this.loadingPageIframe);
            this.loadingPageIframe.contentWindow.document.body.appendChild(style);
            this.loadingPageIframe.contentWindow.document.body.appendChild(this.loadingPageDOM);

            this.initIframeStyle(this.loadingPageIframe);
        },

        // 构建主页面
        createMainPage() {
            console.log(' -- Paas3D load -- ');

            // 获取要插入元素的DOM
            // 移除DOM下的所有子元素
            Array.from(this.mainContent.childNodes).forEach(item => {
                this.mainContent.removeChild(item);
            });

            // 页面加载
            this.createLoadingPage();

            // main的frame
            this.mainFrame = this.createIframe({
                title: 'PaaS 3D & AR Main',
                className: 'paas-3d-main-frame',
                id: 'paas-3d-main-frame'
            });

            this.initIframeStyle(this.mainFrame);

            this.paaSMainDom = this.createDom({
                type: 'div',
                className: 'paaS-main-dom'
            });
            this.paaSMainContent = this.createDom({type: 'div', className: 'paaS-main-content'});
            this.paaSMainDom.appendChild(this.paaSMainContent);
            this.mainContent.appendChild(this.mainFrame);
            this.mainFrame.contentWindow.document.body.appendChild(this.paaSMainDom);

            this.createThemeDisplay();
						// if (this.editContentDom != null) {
						//     if (this.equipment == "pc") {
						//         this.editContentDom.style.height =  `calc(100% - ${this.titlePriceDom.offsetHeight}px - 55px)`;
						//     } else {
						//         this.editContentDom.style.height =  `calc(100% - 25px)`;
						//     }
						// }
						
						this.initStyle({ frame: this.mainFrame });
						if(this.isShowVar) this.createThemeEdit() ;
        },

        // iframe的样式
        initIframeStyle(object) {
            let marginTop = 'unset';
            if (this.classicTemplate.indexOf(this.currentTemplate) == -1) {
                marginTop = '55px';
            }

            // if (window.screen.width > 749) {
                object.style.cssText = `width:100%; height:100%;`;
            // } 
        },

        // 创建3D模型展示页面
        createThemeDisplay() {
            this.themeDisplayDom = this.createDom({
                type: 'div',
                className: 'theme-display'
            });
						
            this.themeDisplayDom.style.width = this.isShowVar && window.screen.width > 749 ? `calc(100% - 400px)` : '100%';
						
            this.createThemeDisplayContent();
            this.createEditDisplayFooter();
            this.paaSMainContent.appendChild(this.themeDisplayDom);
        },

        // 创建3D模型页面 - theme-display-content
        createThemeDisplayContent() {
            const themeDisplayContent = this.createDom({
                type: 'div',
                className: 'theme-display_content'
            });

            const modelContainer = this.createDom({
                type: 'div',
                className: 'view',
                id: 'modelContainer'
            });
            themeDisplayContent.appendChild(modelContainer);
            this.themeDisplayDom.appendChild(themeDisplayContent);

            // 加载3D模型
            this.create3DModel(modelContainer);
        },

        // 创建3D模型页面 - editDisplayFooter
        createEditDisplayFooter() {
            const editDisplayFooter = this.createDom({
                type: 'div',
                className: 'edit-display-footer',
                text: 'Powered by '
            });

            const appNameDom = this.createDom({
                type: 'span',
                className: 'powered-by',
                text: 'Paas3D'
            });

            editDisplayFooter.appendChild(appNameDom);
            this.themeDisplayDom.appendChild(editDisplayFooter);
        },

        // 创建产品信息操作页面
        createThemeEdit() {
            this.themeEditDom = this.createDom({
                type: 'div',
                className: 'theme-edit'
            });
            this.paaSMainContent.appendChild(this.themeEditDom);

            this.createTitlePrice();
            this.createEditContent();
            this.createCardComfirm();

            // this.listenerLoad();
            // this.listenerResize();
        },

        // 产品信息页面 - title-price
        createTitlePrice() {
            this.titlePriceDom = this.createDom({
                type: 'div',
                className: 'title-price'
            });

            // 标题
            const title = this.createDom({
                type: 'div',
                className: 'title',
                text: this.config3d.editorTitle
            });

            // 价格
             this.priceDom = this.createDom({
                type: 'div',
                className: 'price',
                text: `${this.symbol} ${this.config3d.basePrice}`
            });

            this.titlePriceDom.appendChild(title);
            this.titlePriceDom.appendChild(this.priceDom);
            this.themeEditDom.appendChild(this.titlePriceDom);
        },

        // 产品信息页面 - edit-content
        createEditContent() {
            this.editContentDom = this.createDom({
                type: 'div',
                className: 'edit-content'
            });

            const ul = this.createDom({ 
                type: 'ul',
                className: 'edit-content-ul'
            });

            const modelConfig = this.config3d.modelConfig;
            modelConfig.forEach((groupData, index) => {
                //if(index == 0){
                  const liDom = this.createLi(groupData, index);
                  ul.appendChild(liDom);
                //}
            });
            this.editContentDom.appendChild(ul);
            this.themeEditDom.appendChild(this.editContentDom);

            // console.log('初始化 -- selectVariantObj ----------- ', this.selectVariantObj);
            // console.log('初始化 -- selectedVariantIdArray ----------- ', this.selectedVariantIdArray);
            this.renderSubTitleAndPrice();
        },

        // 产品信息页面 - li
        createLi(groupData, index) {
            const li = this.createDom({
                type: 'li',
                className: 'edit-content-li'
            });

            const headDom = this.createEditHead(groupData);

            // console.log('groupData ------------- ', groupData);

            li.appendChild(headDom);
            let bodyDom = null;
            if (groupData.type === 'Answer') {
                bodyDom = this.createEditBodyAnswer(groupData, index);
            } else if (groupData.type === 'AnswerGroup') {
                bodyDom = this.createEditBodyGroupAnswer(groupData, index);
            }

            if (bodyDom != null) {
                li.appendChild(bodyDom);
            }
           
            return li;
        },

        // 创建head
        createEditHead(groupData) {
            const editContentHead = this.createDom({
                type: 'div',
                className: 'edit-content_head'
            });

            const headTitle = this.createDom({
                type: 'div',
                className: 'head_title',
                text: groupData.name
            });

            const headResult = this.createDom({
                type: 'div',
                className: 'head_result'
            });

            editContentHead.appendChild(headTitle);
            editContentHead.appendChild(headResult);

            const that = this;
            editContentHead.onclick = (e) => {
                that.currentLiHeadObj = e;
                that.liOpenOrClose();
            }

            return editContentHead;
        },

        // 创建body - 单个编辑
        createEditBodyAnswer(groupData, index) {
            // 变体整合渲染
            let variantArray = groupData.availableColors;
            if (groupData.availableComponents.length != 0) {
                variantArray = groupData.availableComponents;
            } else if (groupData.blankOptions.length != 0) {
                variantArray = groupData.blankOptions;
            }

            const selectedVariantObj = this.getSelectedVariantId(variantArray, 0);

            this.getconfig3DDataByAnswer(groupData, selectedVariantObj);
            this.renderNameAndPrice(selectedVariantObj, index);

            let typeString = 'one'
            switch(groupData.inputType) {
                case 1:
                    typeString = 'two';
                    break;
                case 2:
                    typeString = 'three';
                    break;
                case 3:
                    typeString = 'four';
                    break;
                case 4:
                    typeString = 'five';
                    break;
                default:
                    typeString = 'one';
                    break;
            }
            const variantTypeDom = this.createTypeVariantCommenFunc(variantArray, groupData, typeString);

            const editContentBody = this.createDom({
                type: 'div',
                className: 'edit-content_body'
            });

            // 描述
            const variantDescription = this.createDom({
                type: 'div',
                className: 'variant-description',
                text: groupData.description
            });

            editContentBody.appendChild(variantDescription);

            if (variantTypeDom != null) {
                editContentBody.appendChild(variantTypeDom);
            }

            return editContentBody;
        },

        // 创建body - 混合编辑
        createEditBodyGroupAnswer(groupData, index) {
            const handlerData = this.handergroupAnswerData(groupData, index);

            const editContentBody = this.createDom({
                type: 'div',
                className: 'edit-content_body'
            });

            // 描述
            const variantDescription = this.createDom({
                type: 'div',
                className: 'variant-description',
                text: groupData.description
            });

            editContentBody.appendChild(variantDescription);

            handlerData.forEach(item => {
                let variantArray = null;
                if (item.availableColors.length > 0) {
                    variantArray = item.availableColors;
                } else if (item.availableComponents.length > 0) {
                    variantArray = item.availableComponents;
                } else if (item.blankOptions.length > 0) {
                    variantArray = item.blankOptions;
                }

                let typeString = 'one'
                switch(item.inputType) {
                    case 1:
                        typeString = 'two';
                        break;
                    case 2:
                        typeString = 'three';
                        break;
                    case 3:
                        typeString = 'four';
                        break;
                    case 4:
                        typeString = 'five';
                        break;
                    default:
                        typeString = 'one';
                        break;
                }
                const variantTypeDom = this.createTypeVariantCommenFunc(variantArray, item, typeString);

                if (variantTypeDom != null) {
                    editContentBody.appendChild(variantTypeDom);
                }
            });

            return editContentBody;
        },

        // 处理混合编辑数据
        handergroupAnswerData(groupData, index) {
            let originalData = [];
            let templateVariantArray = []; // 保存默认选中的变体对象
            let AnswerGroupOptionParam = []; // 存储混合编辑的option
    
            if (groupData.answers) {
                groupData.answers.forEach(item => {
                    item.descripiton = '';
                    originalData.push(item);

                    let selectedVariantObj = {};
                    switch (item.type) {
                        case 'AnswerGroupColorItem' :
                            selectedVariantObj = this.getSelectedVariantId(item.availableColors, item.sortby);
                            templateVariantArray.push(selectedVariantObj);

                            item.availableColors.forEach(colorItem => {
                                if (!colorItem.isDefault) return;
                                const optionParamItem = {
                                    id: colorItem.id,
                                    option: "colors",
                                    tabId: item.id,
                                };
                                AnswerGroupOptionParam.push(optionParamItem);
                            });
                            break;
                        case 'AnswerGroupCompItem' :
                            selectedVariantObj = this.getSelectedVariantId(item.availableComponents, item.sortby);
                            templateVariantArray.push(selectedVariantObj);

                            item.availableComponents.forEach(compItem => {
                                if (!compItem.isDefault) return;
                                const optionParamItem = {
                                    id: compItem.id,
                                    option: "comps",
                                    tabId: item.id,
                                };
                                AnswerGroupOptionParam.push(optionParamItem);
                            })
                            break;
                        case 'AnswerGroupBlankItem' :
                            selectedVariantObj = this.getSelectedVariantId(item.blankOptions, item.sortby);
                            templateVariantArray.push(selectedVariantObj);
                            break;
                    }
                })
            }

            // if (groupData.blanks.length != 0) {
            //     groupData.blanks.forEach(blank => {
            //         blank.description = '';
            //         originalData.push(blank);
            //     })
            // }
            // if (groupData.colors.length != 0) {
            //     groupData.colors.forEach(color => {
            //         color.description = '';
            //         originalData.push(color);
            //         const selectedVariantObj = this.getSelectedVariantId(color.availableColors, color.sortby);
            //         templateVariantArray.push(selectedVariantObj);
    
            //         const optionParamItem = {
            //             "id": color.id,
            //             "option": "colors",
            //             "tabId": groupData.id
            //         };
            //         AnswerGroupOptionParam.push(optionParamItem);
            //     })
            // }
            // if (groupData.comps.length != 0) {
            //     groupData.comps.forEach(comp => {
            //         comp.description = '';
            //         originalData.push(comp);
            //         const selectedVariantObj = this.getSelectedVariantId(comp.availableComponents, comp.sortby);
            //         templateVariantArray.push(selectedVariantObj);
    
            //         const optionParamItem = {
            //             "id": comp.id,
            //             "option": "comps",
            //             "tabId": groupData.id
            //         };
            //         AnswerGroupOptionParam.push(optionParamItem);
            //     })
            // }
    
            const param = {
                "optionParam": AnswerGroupOptionParam,
                "mixGroup": groupData
            }
    
            this.setConfig3DAnswerGroup.push(param);
            this.renderNameAndPrice(templateVariantArray, index);
            return originalData;
        },

        // 创建一个混合编辑的小标题
        createSubHeadTitle(groupData) {
            if (groupData.type !== "Answer") {
                const subHeadTitle = this.createDom({
                    type: 'div', 
                    className: 'head_title sub_head_title',
                    text: groupData.name
                });
                return subHeadTitle;
            }
        },

        // 创建类型的公共方法
        createTypeVariantCommenFunc(variantArray, groupData, type) {
            const variantShowTypeDom = this.createDom({
                type: 'div',
                className: `variant-show-type-${type}`
            });

            const subHeadTitle = this.createSubHeadTitle(groupData)
            if(subHeadTitle != null) {
                variantShowTypeDom.appendChild(subHeadTitle);
            }

            const typeContent = this.createDom({
                type: 'div',
                className: `type-${type}-content`
            });

            if (type === 'two') {
                const dropDownInput = this.createDom({
                    type: 'input',
                    className: 'select-input',
                    way: 'text'
                });
                dropDownInput.readOnly = true; // 只读
                typeContent.appendChild(dropDownInput);

                dropDownInput.onclick = (e) => {
                    if (ul.style.display === 'block') {
                        ul.style.display = 'none';
                    } else {
                        ul.style.display = 'block';
                    }
                }

                this.dropDownInputObj = dropDownInput;
            }
            variantShowTypeDom.appendChild(typeContent);

            const ul = this.createDom({ type: 'ul' })
            variantArray.forEach(variantItem => {
                switch(type) {
                    case 'one':
                        bodyItemContent = this.createTypeOneVariantContent(variantItem, groupData);
                        typeContent.appendChild(bodyItemContent);
                        break;
                    case 'two':
                        bodyItemContent = this.createTypetwoVariantContent(variantItem, groupData);
                        ul.appendChild(bodyItemContent);
                        typeContent.appendChild(ul);
                        break;
                    case 'three':
                        bodyItemContent = this.createTypeThreeVariantContent(variantItem, groupData);
                        typeContent.appendChild(bodyItemContent);
                        break;
                    case 'four':
                        bodyItemContent = this.createTypeFourVariantContent(variantItem, groupData);
                        typeContent.appendChild(bodyItemContent);
                        break;
                    default:
                        bodyItemContent = this.createTypeFiveVariantContent(variantItem, groupData);
                        typeContent.appendChild(bodyItemContent);
                        break;
                }
            });

            return variantShowTypeDom;
        },
        
        // 【第一种】类型变体的item
        createTypeOneVariantContent(variantItem, groupData) {
            const thumbnailBtnContent = this.createDom({
                type: 'div',
                className: 'thumbnail-btn-content'
            });

            let typeOneItemClassName = 'thumbnail-btn';
            if (variantItem.isDefault) {
                typeOneItemClassName = 'thumbnail-btn thumbnail-btn-active';
            }

            const thumbnailBtn = this.createDom({
                type: 'div',
                className: typeOneItemClassName,
                style: `background: ${variantItem.color}`
            });

            // 缩略图
            if (variantItem.displayType) {
                const img = this.createDom({ type: 'img' });
                img.src = variantItem.image;
                thumbnailBtn.appendChild(img);
            }

            const thumbnailBtnVariantName = this.createDom({
                type: 'div',
                className: 'thumbnail-btn-variant-name',
                text: `${variantItem.name}`
            });

            thumbnailBtnContent.appendChild(thumbnailBtn);
            thumbnailBtnContent.appendChild(thumbnailBtnVariantName);

            const that = this;
            thumbnailBtn.onclick = function(e) {
                const paramsObj = {
                    "config3d": groupData,
                    "currentVariant": variantItem,
                    "event": e,
                    "variantId": variantItem.id
                }
                that.typeOneVariantClick(paramsObj);
            }

            return thumbnailBtnContent;
        },

        // 【第一种】类型变体点击后
        typeOneVariantClick(paramObj) {
            const currentLabelBtn = paramObj.event.target; // 当前的label btn
            const currentTypeFourCont = currentLabelBtn.parentNode.parentNode;
            const labelBtnDom = Array.from(currentTypeFourCont.querySelectorAll(".thumbnail-btn"));

            // 通过设置类名来设置样式
            labelBtnDom.forEach(labelItem => {
                labelItem.setAttribute("class", "thumbnail-btn");
            });
            currentLabelBtn.setAttribute("class", "thumbnail-btn label-button-active");
            this.handlerVariantClick(paramObj);
        },

        // 【第二种】类型变体的item
        createTypetwoVariantContent(variantItem, groupData) {
            const li = this.createDom({
                type: 'li',
                text: `${variantItem.name}`
            });

            // 默认值
            if (variantItem.isDefault) {
                this.dropDownInputObj.value = variantItem.name;
            }

            const that = this;
            li.onclick = (e) => {
                const paramsObj = {
                    "config3d": groupData,
                    "currentVariant": variantItem,
                    "event": e,
                    "variantId": variantItem.id
                }
                that.typeTwoVariantClick(paramsObj);
            }
            return li;
        },

        // 【第二种】类型变体点击后
        typeTwoVariantClick(paramObj) {
            const inputDom = paramObj.event.target.parentNode.parentNode.querySelector('input');
            inputDom.value = paramObj.currentVariant.name;
            paramObj.event.target.parentNode.style.display = 'none';

            this.handlerVariantClick(paramObj);
        },

        // 【第三种】类型变体的item
        createTypeThreeVariantContent(variantItem, groupData) {
            const radioDom = this.createDom({
                type: 'div',
                className: 'radio'
            });

            const inputDom = this.createRadio({
                className: 'variant-radio',
                groupData,
                variantItem
            });

            const labelDom = this.createDom({
                type: 'label',
                for: variantItem.id
            });

            const spanDom = this.createDom({
                type: 'span',
                text: `${ variantItem.name }`
            });

            radioDom.appendChild(inputDom);
            radioDom.appendChild(labelDom);
            radioDom.appendChild(spanDom);

            const that = this;
            labelDom.onclick = (e) => {
                const paramsObj = {
                    "config3d": groupData,
                    "currentVariant": variantItem,
                    "event": e,
                    "variantId": variantItem.id
                }
                that.typeThreeVariantClick(paramsObj);
            }

            return radioDom;
        },

        // 【第三种】类型变体点击后
        typeThreeVariantClick(paramsObj) {
            this.handlerVariantClick(paramsObj);
        },

        // 【第四种】类型变体的item
        createTypeFourVariantContent(variantItem, groupData) {
            let typeFourItemClassName = 'label-button';
            if (variantItem.isDefault) {
                typeFourItemClassName = 'label-button label-button-active';
            }

            const lableButton = this.createDom({
                type: 'button',
                className: typeFourItemClassName,
                text: `${variantItem.name}`
            });

            const that = this;
            lableButton.onclick = (e) => {
                const paramsObj = {
                    "config3d": groupData,
                    "currentVariant": variantItem,
                    "event": e,
                    "variantId": variantItem.id
                }
                that.typeFourVariantClick(paramsObj);
            }

            return lableButton;
        },

        // 【第四种】类型变体点击后
        typeFourVariantClick(paramObj) {
            const currentLabelBtn = paramObj.event.target; // 当前的label btn
            const currentTypeFourCont = currentLabelBtn.parentNode.parentNode;
            const labelBtnDom = Array.from(currentTypeFourCont.querySelectorAll(".label-button"));

            // 通过设置类名来设置样式
            labelBtnDom.forEach(labelItem => {
                labelItem.setAttribute("class", "label-button");
            });
            currentLabelBtn.setAttribute("class", "label-button label-button-active");
            this.handlerVariantClick(paramObj);
        },

        // 【第五种】类型变体的item
        createTypeFiveVariantContent(variantItem, groupData) {
            const inputDom = this.createDom({
                type: 'div',
                className: 'input-dom'
            });

            const textInput = this.createDom({
                type: 'input',
                className: 'text-input'
            });

            inputDom.appendChild(textInput);

            return inputDom;
        },

        // 处理变体点击后的逻辑
        handlerVariantClick(paramObj) {
            if (paramObj.config3d.type === 'Answer') {
                // 单个编辑渲染
                this.mainFrame.contentWindow.viewer.applyAnswer(paramObj.config3d, paramObj.currentVariant.id);
            } else {
                // 混合编辑渲染
                let currentMixOptionObj = {
                    "id": paramObj.currentVariant.id,
                    "option": "",
                    "tabId": ""
                };
                let typeFlag = "";
    
                if (paramObj.config3d.type === "AnswerGroupColorItem") {
                    currentMixOptionObj["option"] = "colors"; 
                    typeFlag = "colors";
                } else if (paramObj.config3d.type === "AnswerGroupCompItem") {
                    currentMixOptionObj["option"] = "comps"; 
                    typeFlag = "comps";
                } else {
                    currentMixOptionObj["option"] = "blank";
                    typeFlag = "blank";
                }
                
                // 从总的3D数据中获取当前操作的3D配置
                const current3DObj = this.config3d.modelConfig.find(productItem => {
                    if (productItem.type === "AnswerGroup") {
                        return productItem.answers.find(answerItem => {
                            if (typeFlag === "colors" && answerItem.type === 'AnswerGroupColorItem') {
                                return answerItem.availableColors.find(color => {
                                    return color.id === paramObj.variantId;
                                })
                            } else if (typeFlag === "comps" && answerItem.type === 'AnswerGroupCompItem') {
                                return answerItem.availableComponents.find(comps => {
                                    return comps.id === paramObj.variantId;
                                })
                            }
                        })
                    }
                });
                
                if (current3DObj) {
                    currentMixOptionObj["tabId"] = paramObj.config3d.id;
                    this.mainFrame.contentWindow.viewer.applyAnswerGroup(current3DObj, [currentMixOptionObj]);
                }
            }

            // 排序标识
            const subSort = paramObj.config3d.sortby;

            // 获取当前的li
            let currentDom = paramObj.event.target;
            for (let index = 0; index < 5; index++) {
                currentDom = currentDom.parentNode;
                if (currentDom.tagName === 'LI') break;
            }

            // 当前li的位置下标
            let childCount = 0;
            while((currentDom = currentDom.previousSibling) != null) {
                childCount++ ;
            }

            // 重新构建当前点击的变体对象
            const liObj = {
                "array": paramObj.currentVariant,
                "defaultName": [paramObj.currentVariant.name],
                "index": childCount
            }

            // 重新构建选中后的3D数据
            this.selectVariantObj.forEach((item, index) => {
                if (item.index === childCount) {
                    if (!(item.array instanceof Array)) {
                        // 单个编辑
                        this.selectVariantObj[index] = liObj;
                    } else {
                        // 混合编辑
                        item.array.forEach((arrayItem, subIndex) => {
                            if (arrayItem.subIndex == subSort) {
                                // 本身没有选中的变体数据时没有subSort属性的，匹配上了就给他加上
                                paramObj.currentVariant = {
                                    ...paramObj.currentVariant,
                                    subIndex: subSort
                                }
                                this.selectVariantObj[index].array[subIndex] = paramObj.currentVariant;
                            }
                        });
    
                        let nameArray = '';
                        item.array.forEach(arrayItem => {
                            if (!arrayItem.name) return;
                            nameArray += ' ' + arrayItem.name;
                        });
                        this.selectVariantObj[index].defaultName = [nameArray];
                    }
                }
            });

            // 根据3D数据重新构建选中的3D数据的ID数组
            let selectVariantIdArray = [];
            this.selectVariantObj.forEach(item => {
                if (item.array instanceof Array) {
                    // 混合编辑
                    item.array.forEach(subItem => {
                        if (subItem.id) {
                            selectVariantIdArray.push(subItem.id);
                        }
                    })
                } else {
                    // 单个编辑
                    if (item.array.id) {
                        selectVariantIdArray.push(item.array.id);
                    }
                }
            });
            
            this.selectedVariantIdArray = selectVariantIdArray;
            this.renderSubTitleAndPrice();
        },

        // 初始化时 - 获取isDefault为true的3D数据id
        getSelectedVariantId(variantObj, sortby) {
            let currentObj = variantObj.find(item => {
                return item.isDefault;
            });
    
            if (!currentObj) {
                return { subIndex: sortby };
            }
    
            currentObj = {
                ...currentObj,
                subIndex: sortby
            } 
            this.selectedVariantIdArray.push(currentObj.id);
            return currentObj;
        },

        // 【初始化】获取isDefault为true的3D数据 - 单个编辑
        getconfig3DDataByAnswer(groupData, selectedVariantObj) {
            if (Object.keys(selectedVariantObj).length > 1) {
                const param = {
                    id: selectedVariantObj.id,
                    threeDObj: groupData
                }
                this.setConfig3DAnswer.push(param);
            }
        },

        // 【初始化】根据isDefault为true的变体ID渲染name和price
        renderNameAndPrice(selectedVariantObj, index) {
            if (selectedVariantObj) {
                let isDefaultVariantNameArray = []; // 保存默认选中的变体名称
    
                // 截取默认选中变体的名称
                if (selectedVariantObj instanceof Array) {
                    // 混合编辑
                    let nameString = "";
                    selectedVariantObj.forEach((selectVariantItem, index) => {
                        if (Object.keys(selectVariantItem).length === 1) return;
                        nameString += " " + selectVariantItem.name;
                    });
                    isDefaultVariantNameArray.push(nameString);
                } else {
                    // 单个编辑
                    if (Object.keys(selectedVariantObj).length === 1) {
                        isDefaultVariantNameArray.push(' ');
                    } else {
                        isDefaultVariantNameArray.push(selectedVariantObj.name);
                    }
                }
    
                const liObj = {
                    "index": index,
                    "array": selectedVariantObj,
                    "defaultName": isDefaultVariantNameArray
                }
    
                this.selectVariantObj.push(liObj);
            }
        },

        // 渲染每个head的选中内容和总价格
        renderSubTitleAndPrice() {
            const editHeadArray = Array.from(this.editContentDom.querySelectorAll('.head_result'));

            if (editHeadArray.length === 0) return; 

            let totalPrice = 0; // 总价: 税费 + 变体总价
            let selectedVariantTotalPrice = 0; // 变体总价

            this.selectVariantObj.forEach((item, index) => {
                if (!editHeadArray[item.index]) return;
                editHeadArray[item.index].innerHTML = item.defaultName[0];

                // 计算选中的变体总价
                if (item.array instanceof Array) {
                    // 混合编辑
                    item.array.forEach(subItem => {
                        if (Object.keys(subItem).length === 1) return;
                        selectedVariantTotalPrice += Number(subItem.price);
                    });
                } else {
                    // 单个编辑
                    if (Object.keys(item.array).length === 1) return;
                    selectedVariantTotalPrice += Number(item.array.price);
                }
            });

            totalPrice = Number(this.config3d.basePrice) + selectedVariantTotalPrice;
            if (this.config3d.taxRateSwitch) {
                totalPrice += Number(this.config3d.basePrice) * this.config3d.taxRate / 100;
            } 

            // this.priceDom.innerHTML = `${this.symbol} ${totalPrice}`;
        },

        // 产品信息页面 - card-comfirm
        createCardComfirm() {
            const cardComfirm = this.createDom({
                type: 'div',
                className: 'card-comfirm'
            });

            this.addToCart = this.createDom({
                type: 'div',
                className: 'add-to-cart',
                text: this.themeData.translation.Translation
                //text: "→"
            });

            this.confirmBtn = this.createDom ({
                type: 'div',
                className: 'add-to-cart confirm-btn',
                // text: '√'
            });

            const svg = this.createSVG();
            cardComfirm.appendChild(this.addToCart);
            cardComfirm.appendChild(this.confirmBtn);
            this.confirmBtn.appendChild(svg);

            const that = this;
            this.confirmBtn.onclick = () => {
                if (that.headClickFlag) {
                    that.headClickFlag = 0;
                    that.liOpenOrClose();
                }
            }

            // 加入购物车
            this.addToCart.onclick = () => {
                 if (that.addToCartFlag) {
                     that.addToCartFlag = 0;
                     that.addToCartLoadingDom = that.createAddToCartLoadingPage();
                     that.addToCart.innerHTML = '';
                     that.addToCart.appendChild(that.addToCartLoadingDom);
                     that.getVariantId();
                 }
            }
            this.themeEditDom.appendChild(cardComfirm);
        },

        // addToCart加载页面
        createAddToCartLoadingPage() {
            const loadingDiv = this.createDom({
                type: 'div',
                className: 'cart-loading-dom'
            });

            const spinner = this.createDom({
                type: 'div',
                className: 'spinner'
            });

            for(let i = 1; i <= 3; i++) {
                const rect = this.createDom({
                    type: 'div',
                    className: `rect${i}`
                });
                spinner.appendChild(rect);
            }

            loadingDiv.appendChild(spinner);
            return loadingDiv;
        },

        // addToCart动画移除
        removeAddToCartLoading() {
            this.addToCart.removeChild(this.addToCartLoadingDom);
            this.addToCart.innerHTML = this.themeData.translation.Translation;
            this.addToCartFlag = 1;
        },

        // 创建一个报错弹窗
        createErrorPage(errorText) {
            const errorDom = this.createDom({
                type: 'div',
                className: 'paaS-error-dialog',
                text: errorText
            });
            this.paaSMainContent.appendChild(errorDom);

            setTimeout(() => {
                this.paaSMainContent.removeChild(errorDom);
            }, 6000);
        },

        // edit-content_head点击之后 【开启或关闭】
        liOpenOrClose() {
            const e = this.currentLiHeadObj; // 当前的event对象
            let currentLi = null; // 当前点击的父元素 - li

            if (e.target) {
                currentLi = e.target.parentNode;
            } else {
                currentLi = e.parentNode;
            }

            const currentUl = currentLi.parentNode; // ul
            const contentBody = currentUl.parentNode; // edit-content

            const currentLiCont = currentLi.querySelector('.edit-content_body');
            const liDomArray = currentUl.querySelectorAll('.edit-content-li'); // ul下所有的li子元素

            let childCount = 0;
            while ((currentLi = currentLi.previousSibling) != null) {
                childCount++ ;
            }
            
            if (!this.liOpenOrCloseFlag) {
                if (this.equipment === "pc") {
                    contentBody.scrollTop = 0;
                    liDomArray.forEach((liItem, index) => {
                        if (childCount === 0) {
                            if (index != 0) {
                                liItem.style.transform = `translateY(560px)`;
                            } else {
                                currentLiCont.style.display = 'block';
                            }
                        } else {
                            if (index < childCount) {
                                const distant = (index + 1) * 72;
                                liItem.style.transform = `translateY(${-distant}px)`;
                            } else if (index > childCount) {
                                liItem.style.transform = `translateY(560px)`;
                            } else {
                                const distant = index * 72;
                                liItem.style.transform = `translateY(${-distant}px)`;
                                currentLiCont.style.display = 'block';
                            }
                        }
                    });
                    contentBody.style.overflowY = 'hidden';
                } else {
                    currentUl.scrollLeft = 0;
                    liDomArray.forEach((liItem, index) => {
                        if (childCount === 0) {
                            if (index != 0) {
                                liItem.style.transform = `translateX(282px)`;
                            } else {
                                liItem.style.transform = `translateX(-196px)`;
                                currentLiCont.style.display = 'block';
                                currentLiCont.style.left = '196px';
                            }
                        } else {
                            if (index < childCount) {
                                const distant = (index + 1) * 196;
                                liItem.style.transform = `translateX(${-distant}px)`;
                            } else if (index > childCount) {
                                liItem.style.transform = `translateX(196px)`;
                            } else {
                                const distant = (index + 1) * 196;
                                liItem.style.transform = `translateX(${-distant}px)`;
                                currentLiCont.style.display = 'block';
                                currentLiCont.style.left = '196px';
                            }
                        }
                    });
                    currentUl.style.overflowX = 'hidden';
                }
                this.confirmBtn.style.transform = 'translateX(414px)';

                if (this.config3d.modelConfig[childCount].cameraAngle && this.config3d.modelConfig[childCount].cameraAngle.viewPort) {
                    this.mainFrame.contentWindow.viewer.setViewPort(this.config3d.modelConfig[childCount].cameraAngle.viewPort.viewPort, true);
                }
                
                this.liOpenOrCloseFlag = 1;
            } else {
                liDomArray.forEach(liItem => {
                    liItem.style.transform = `translateY(0px)`;
                    currentLiCont.style.display = 'none';
                });
                this.confirmBtn.style.transform = 'translateX(0px)';
                setTimeout(() => {
                    if (this.equipment === "pc") {
                        contentBody.style.overflowY = 'auto';
                    } else {
                        currentUl.style.overflowX = 'auto';
                    }
                }, 200);
                this.liOpenOrCloseFlag = 0;
            }

            setTimeout(() => {
                this.headClickFlag = 1;
            })
        },

        // 构建3D模型
        create3DModel(modelContainer) {
           
            const dict = {
                type: "module",
                src: this.THREE_URL
            };

            const that = this;
            this.loadScript(dict, function () {
                setTimeout(() => {
                    that.mainFrame.contentWindow.initViewer(modelContainer, that.apiData.config3d, () => {
                        that.render3DModel();
                    });
                }, 300)
            });
        },

        // 【初始化】3D渲染
        render3DModel() {
            // 单个编辑
            this.setConfig3DAnswer.forEach(item => {
                this.mainFrame.contentWindow.viewer.applyAnswer(item.threeDObj, item.id);
            });

            // 混合编辑
            this.setConfig3DAnswerGroup.forEach(item => {
                this.mainFrame.contentWindow.viewer.applyAnswerGroup(item.mixGroup, item.optionParam);
            });

            this.paaSMainDom.style.visibility = 'visible';
            // this.initIframeStyle(this.mainFrame);
            this.mainContent.removeChild(this.loadingPageIframe);

            // 【新增订制】
            const currentLiArray = this.mainFrame.contentWindow.document.querySelectorAll('.edit-content-li');
            if (currentLiArray.length > 0) {
                this.currentLiHeadObj = currentLiArray[0].querySelector(".edit-content_head");
                // this.liOpenOrClose();
            }
        },

        // 3D模型script的创建
        loadScript(dict, cb) {
            var script = this.mainFrame.contentWindow.document.createElement("script");
            for (var key in dict) {
                var val = dict[key];
                script.setAttribute(key, val);
            }
            script.async = true;
            this.mainFrame.contentWindow.document.body.appendChild(script);
            script.onload = function () {
                cb && cb();
            }
        },

        // 加入购物车前 - 根据当前选中的变体ID查询一个总的产品ID
        getVariantId() {
            let apiParamObj = [];
            this.selectedVariantIdArray.forEach(item => {
                const obj = { id: item };
                apiParamObj.push(obj);
            });

            // const that = this;
            // this.ajaxRequest({
            //     url: `${that.API_BASE_URL}proxy/variations?shop=${that.domain}`,
            //     data: {
            //         id: that.apiData.id,
            //         product3dVariantParams: apiParamObj
            //     },
            //     success: function(res) {
            //         const params = JSON.parse(res);
            //         if (params.code === 200) {
            //             that.toCartOfShopify(params.data);
            //         } else {
            //             const errorText = 'Service error, please try again later.';
            //             that.createErrorPage(errorText);
            //             that.removeAddToCartLoading();
            //         }
            //     }
            // });
           // 统计订单备注信息
            const orderRemarkContent = this.getOrderNotes();

            const that = this;
            this.ajaxRequest({
                url: `${that.API_BASE_URL}proxy/variations?shop=${that.domain}`,
                data: {
                    id: that.apiData.id,
                    product3dVariantParams: apiParamObj,
                    notes: orderRemarkContent
                },
                success: function(res) {
                    const params = JSON.parse(res);
                    if (params.code === 200) {
                        that.toCartOfShopify(params.data);
                    } else {
                        const errorText = 'Service error, please try again later.';
                        that.createErrorPage(errorText);
                        that.removeAddToCartLoading();
                    }
                }
            });
        },

        
        // 获取订单备注
        getOrderNotes() {
            const orderRemarkDom = Array.from(this.paaSMainContent.querySelectorAll('.type-five-input'));
            let orderRemarkContent = '';
            orderRemarkDom.forEach(item => {
                if (item.value) {
                    orderRemarkContent += item.value + ' ';
                }
            });

            return orderRemarkContent;
        },

         // 调用shopify加入购物车api - TODO
        toCartOfShopify(data) {
            const resultParam = this.getVariantObj();

            let formData = {
                'items': data.items,
                'note': data.note
            };

            const that = this;
            fetch(`${Shopify.routes.root}cart/add.js`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            }).then(res => {
                if (res.status === 200) {
                    window.location.href = `${Shopify.routes.root}cart`;
                } else {
                    const errorText = 'There was an error adding your product to the cart, please try again.';
                    that.createErrorPage(errorText);
                }
                that.removeAddToCartLoading();
            }).catch(error => {
                const errorText = 'There was an error adding your product to the cart, please try again.';
                that.createErrorPage(errorText);
                that.removeAddToCartLoading();
            });
        },
        // 调用shopify加入购物车api - TODO
        toCartOfShopify1(data) {
            // 获取订单备注
            const orderRemarkDom = Array.from(this.paaSMainContent.querySelectorAll('.text-input'));
            let orderRemarkContent = '';
            orderRemarkDom.forEach(item => {
                if (item.value) {
                    orderRemarkContent += item.value + ' ';
                }
            });

            const resultParam = this.getVariantObj();

            let formData = {
                'items': [{
                    'id': data,
                    'quantity': 1,
                    'properties': {}
                }],
                'note': orderRemarkContent
            };

            let properties = {};
            resultParam.forEach(item => {
                properties[item.groupName] = item.title;
            });
            
            formData.items[0].properties = properties;

            const that = this;
            fetch(`${Shopify.routes.root}cart/add.js`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            }).then(res => {
                if (res.status === 200) {
                    window.location.href = `${Shopify.routes.root}cart`;
                } else {
                    const errorText = 'There was an error adding your product to the cart, please try again.';
                    that.createErrorPage(errorText);
                }
                that.removeAddToCartLoading();
            }).catch(error => {
                const errorText = 'There was an error adding your product to the cart, please try again.';
                that.createErrorPage(errorText);
                that.removeAddToCartLoading();
            });
        },

        // 加入购物车时，获取选中的变体和变体名称（格式-> key: value。混合编辑的数据取到内部的小标题）
        getVariantObj() {
            let resultParam = [];
            this.selectVariantObj.forEach(selectVariantObjItem => {
                if (Array.isArray(selectVariantObjItem.array)) {
                    // 混合编辑
                    let variantArray = [];
                    const config3DVariantObj = this.config3d.modelConfig[selectVariantObjItem.index]; 
                    if (config3DVariantObj.colors.length > 0) {
                        config3DVariantObj.colors.forEach(colorItem => {
                            variantArray.push(colorItem);
                        });
                    }
                    if (config3DVariantObj.comps.length > 0) {
                        config3DVariantObj.comps.forEach(compsItem => {
                            variantArray.push(compsItem);
                        });
                    }

                    let titleString = '';
                    selectVariantObjItem.array.forEach(item => {
                        if (Object.keys(item).length > 1) {
                            const currentVariantObj = variantArray.find(variantArrayItem => {
                                return variantArrayItem.sortby == item.subIndex;
                            });

                            if (currentVariantObj != null) {
                                titleString += `${currentVariantObj.name}:${item.name} `;
                            }
                        }
                    });
                    
                    if (titleString != '') {
                        const resultObj = {
                            'groupName': this.config3d.modelConfig[selectVariantObjItem.index].name,
                            'title': titleString
                        }
                        resultParam.push(resultObj);
                    }
                } else {
                    // 单个编辑
                    if (Object.keys(selectVariantObjItem.array).length > 1) {
                        const resultObj = {
                            'groupName': this.config3d.modelConfig[selectVariantObjItem.index].name,
                            'title': selectVariantObjItem.defaultName[0]
                        }
                        resultParam.push(resultObj);
                    }
                }
            });
            return resultParam;
        }
    }

    // const __PaaS = new PaaS();
    return (global.__PaaSBall = PaaSBall);
})(window)